import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';

class UaePassCallBack extends Component {

    componentDidMount() {

        const params = new URLSearchParams(window.location.search);

        const code = params.get("code");
        const state = params.get("state");
        const error = params.get("error");

        console.log("Callback Loaded:", window.location.href);

        if (error) {
            console.log("UAE PASS Error:", error);
            window.close();
            return;
        }

        if (code && window.opener) {

            console.log("Code Found:", code);

            window.opener.postMessage(
                { code, state },
                window.location.origin
            );

            window.close();
        }
    }

    render() {
        return (
            <Row className='h-100 d-flex align-items-center justify-content-center'>
                <div>Processing UAE PASS Login...</div>
            </Row>
        );
    }
}

UaePassCallBack.contextTypes = {
    router: PropTypes.object
};

export default UaePassCallBack;
